import { RadioField, SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { Grid, Typography } from '@material-ui/core';
import { useLoanStore } from '@roc/feature-loans';

export const RequestBankInformation = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();
  const { loanStore } = useLoanStore();

  const confirmHandler = () => {
    drawActionsStore.sendDocusign(drawId, afterActionExecuted);
  }

  return (
    <SubmitDialog
      title="Verify Wire Details"
      open={drawActionsStore.isRequestBankInformationDialogOpen}
      body={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">Are you sure you want to send a wire details verification to {loanStore?.loanDetails?.authorizedSignatoryEmail}?</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">A new Docusign will be needed, and the wire authorization document will remain pending until the process is complete.</Typography>
          </Grid>
          <Grid item xs={12}>
            <RadioField
              standaloneLabel
              label="Would you like to send the DocuSign with Identity Verification?"
              name={'docusignVerification'}
              options={[{
                label: 'Yes',
                value: 'withIdVerification',
              }, {
                label: 'No',
                value: 'withoutIdVerification',
              }]
              }
              value={drawActionsStore?.docusignVerification}
              onChange={value => drawActionsStore.setDocusignVerification(value)}
              fullWidth
              row
              testId="docusignVerification"
              tooltip="Identity Verification is a method used to confirm a user's identity, requiring the user to upload a selfie along with one or more images of their identification documents. This process ensures the authenticity of the individual's identity."
              useCustomTooltip
            />
          </Grid>
        </Grid>
      }
      handleClose={() => drawActionsStore.setIsRequestBankInformationDialogOpen(false)}
      handleOk={confirmHandler}
      cancelButtonText='Cancel'
      okButtonText='Confirm'
    />
  );
});
